import { render, staticRenderFns } from "./DirectSaleStore.vue?vue&type=template&id=f0842b0a&scoped=true&"
import script from "./DirectSaleStore.vue?vue&type=script&lang=js&"
export * from "./DirectSaleStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0842b0a",
  null
  
)

export default component.exports